import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { routes } from '../../../../environments/shared-environment/routes';
import { CloudflareTurnstileService } from '../../components/cloudflare-turnstile/services/cloudflare-turnstile.service';

const protectedRoutes: string[] = [routes.auth.login];

const protectedRoutesParts: string[][] = protectedRoutes.map(route => route.split('/').filter(Boolean));

function matchProtectedRoute(rawUrl: string): boolean {
  const isLocalEnvironment = rawUrl.includes('localhost:3000');
  // example.com/api/v1/auth/login -> [api, v1, auth, login]
  // localhost:3000/auth/login -> [auth, login]
  const start = isLocalEnvironment ? 0 : 2;

  const url = new URL(rawUrl);
  const urlParts: string[] = url.pathname.split('/').filter(Boolean);
  const urlPartsWithoutBase: string[] = urlParts.splice(start, urlParts.length);

  return protectedRoutesParts.some(routeParts => routeParts.length === urlPartsWithoutBase.length && routeParts.every((part: string, i: number): boolean => (part.startsWith('{') && part.endsWith('}')) || part === urlPartsWithoutBase[i]));
}

export const cloudflareTurnstile: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const cloudflareTurnstileService = inject(CloudflareTurnstileService);
  const shouldAddToken = matchProtectedRoute(req.url);
  const token = cloudflareTurnstileService.get();

  if (!token || !shouldAddToken) {
    return next(req);
  }

  const requestWithHeader = req.clone({
    setHeaders: {
      'cf-turnstile-token': token
    }
  });

  return next(requestWithHeader);
};
